import API from './api';
import { authUpdatePasswordToken } from './actions/auth';

//Login
import NonLoggedLayout from './components/NonLoggedLayout';
import Login from './containers/Login';
import RestorePassword from './components/auth/RestorePassword';
import UpdatePassword from './components/auth/UpdatePassword';

import LoggedLayout from './components/LoggedLayout';
//index
import Page404 from './components/Page404';
// routes
import managersRouter from './components/Managers/router';
import cityEventsRouter from './components/CityEvents/router';
import clubsRouter from './components/Clubs/router';
import fanBoxRouter from './components/FanBox/router';
import fanFeedRouter from './components/FanFeed/router';
import settingsRouter from './components/Settings/router';
import newsSettings from './components/News';
import participantSettings from './components/Participants';
import playersSettings from './components/Players';
import eventSettings from './components/Events';
import competitionsSettings from './components/Competitions';
import shopSettings from './components/Shop';
import partnerSettings from './components/Partner';
import promotionSettings from './components/Promotions/index';
import ConfirmSignUp from './components/ConfirmSignUp';
import { CustomStream } from './components/Stream/CustomStream';
import { LiveStream } from './components/Stream/LiveStream';
import * as clubCMS from './components/ClubCMS';

function redirectToLogin(nextState, replace, callback) {
  API.Auth.logPromise.then(() => {
    if (!API.Auth.loggedIn) {
      replace({
        pathname: '/login',
        state: { nextPathname: nextState.location.pathname }
      });
    }
    callback();
  });
}

function redirectToMain(nextState, replace, callback) {
  API.Auth.logPromise.then(() => {
    if (API.Auth.loggedIn) {
      replace('/fanbox');
    }
    callback();
  });
}

const checkStreamProvider = store => {
  let {
    auth: { user }
  } = store.getState();
  let streamProvider = user ? user.club.stream_provider : 'default';
  switch (streamProvider) {
    case 'livestream':
      return LiveStream.router;
    case 'custom':
      return CustomStream.router;
    default:
      return LiveStream.router;
  }
};

const checkConfirmToken = store =>
  async function(nextState, replace, callback) {
    let {
      location: {
        query: { token }
      }
    } = nextState;
    let response = await API.Auth.checkConfirmToken(token);
    store.dispatch(authUpdatePasswordToken(response));
    callback();
  };

export default store => ({
  childRoutes: [
    // non secure zone
    {
      onEnter: redirectToMain,
      component: NonLoggedLayout,
      childRoutes: [
        { path: '/login', component: Login },
        { path: '/restore_password', component: RestorePassword },
        { path: '/update_password/:token', component: UpdatePassword },
        {
          path: '/confirm_signup',
          component: ConfirmSignUp,
          onEnter: checkConfirmToken(store)
        }
      ]
    },
    // secure zone
    {
      onEnter: redirectToLogin,
      path: '/',
      component: LoggedLayout,
      indexRoute: {
        onEnter: (nextState, replace) => replace('/fanbox')
      },
      getChildRoutes: (partialNextState, cb) =>
        cb(null, [
          managersRouter,
          cityEventsRouter,
          clubsRouter,
          fanBoxRouter,
          fanFeedRouter,
          settingsRouter,
          newsSettings.router,
          ...participantSettings.router,
          ...playersSettings.router,
          ...eventSettings.router,
          ...competitionsSettings.router,
          ...promotionSettings.router,
          shopSettings.router,
          partnerSettings.router,
          ...clubCMS.router,
          ...checkStreamProvider(store),
          { path: '*', component: Page404 }
        ])
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router.jsx